import React from 'react';
import PropTypes from 'prop-types';
import {
  Checkbox, FormControl, InputLabel, ListItemText, MenuItem, OutlinedInput, Select, Typography
} from '@mui/material';
import RelatedCard from './RelatedCard';
import RelatedTable from './RelatedTable';

/**
 * The owner's consumers: the one card that both shows and sets its list.
 *
 * The picker stays here rather than in the details form so consumers have a single home -
 * seeing which ones are attached and changing them are the same act.
 */

const COLUMNS = [
  {field: 'name', headerName: 'Name'},
  {field: 'consumer_type_name', headerName: 'Type', render: (row) => row.consumer_type_name || '—'},
];

const ConsumersCard = ({consumers, selected, setSelected}) => (
  <RelatedCard title='Consumers' count={selected.length}>
    <FormControl fullWidth size='small' sx={{mb: 1.5}}>
      <InputLabel id='consumers-label'>Attached consumers</InputLabel>
      <Select
        labelId='consumers-label'
        id='consumers-multi-select'
        label='Attached consumers'
        multiple
        value={selected}
        onChange={(event) => setSelected(event.target.value)}
        input={<OutlinedInput label='Attached consumers'/>}
        renderValue={(chosen) => chosen?.map((x) => x.name).join(', ')}
      >
        {(consumers || []).map((consumer) => (
          <MenuItem key={consumer.id} value={consumer}>
            <Checkbox checked={selected?.find((x) => x.name === consumer.name) !== undefined}/>
            <ListItemText primary={consumer.name}/>
          </MenuItem>
        ))}
      </Select>
    </FormControl>

    {selected.length === 0 ? (
      <Typography variant='body2' color='textSecondary' sx={{py: 1, textAlign: 'center'}}>
        No consumers are attached to this owner.
      </Typography>
    ) : (
      <RelatedTable columns={COLUMNS} rows={selected} maxHeight={168}/>
    )}
  </RelatedCard>
);

ConsumersCard.propTypes = {
  consumers: PropTypes.array,
  selected: PropTypes.array,
  setSelected: PropTypes.func.isRequired,
};

ConsumersCard.defaultProps = {consumers: [], selected: []};

export default ConsumersCard;
